import { useEffect, useRef } from 'react';

interface InfiniteScrollSentinelProps {
  loadMore: (numItems: number) => void;
  status: 'CanLoadMore' | 'LoadingMore' | 'Exhausted' | 'LoadingFirstPage';
  batchSize?: number;
}

export function InfiniteScrollSentinel({
  loadMore,
  status,
  batchSize = 40,
}: InfiniteScrollSentinelProps) {
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (status !== 'CanLoadMore') return;
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMore(batchSize);
        }
      },
      { rootMargin: '200px' },
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [status, loadMore, batchSize]);

  if (status === 'Exhausted') return null;

  return (
    <div ref={sentinelRef} className="flex justify-center py-4">
      {(status === 'LoadingMore' || status === 'LoadingFirstPage') && (
        <span className="loading loading-spinner loading-md" />
      )}
    </div>
  );
}
